import { Task, TaskFishImport, TaskVaccination, TaskEnvAttrsModifier } from "@/types/v2";

export function isVaccinationTask(task: Task): task is TaskVaccination {
  return task.objective.id === "vaccination";
}

export function isEnvironmentalTask(task: Task): task is TaskVaccination {
  return task.objective.id === "environmental";
}

export function isMortalityTask(task: Task): task is TaskVaccination {
  return task.objective.id === "mortality";
}

export function isFishImportTask(task: Task): task is TaskFishImport {
  return task.objective.id === "fish_import";
}

export function isEnvAttrsModifierTask(task: Task): task is TaskEnvAttrsModifier {
  return task.objective.id === "environmental_modifier";
}